var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGatewayIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_24283",
  "data-name": "Group 24283",
  transform: "translate(16685 17405)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_4996",
  "data-name": "Rectangle 4996",
  width: 24,
  height: 24,
  transform: "translate(-16685 -17405)",
  fill: "inherit",
  opacity: 0
}), /*#__PURE__*/React.createElement("path", {
  id: "Union_5",
  "data-name": "Union 5",
  d: "M6,22a3,3,0,0,1-3-3V17H1a1,1,0,0,1,0-2H3V7H1A1,1,0,0,1,1,5H3V3A3,3,0,0,1,6,0H8a3,3,0,0,1,3,3V5h1.228a2.3,2.3,0,1,1,0,2H11v3h5.171a3,3,0,1,1,0,2H11v3h1.929a2.3,2.3,0,1,1,0,2H11v2a3,3,0,0,1-3,3ZM5,19a1,1,0,0,0,1,1H8a1,1,0,0,0,1-1V3A1,1,0,0,0,8,2H6A1,1,0,0,0,5,3V5H7A1,1,0,0,1,7,7H5v8H7a1,1,0,0,1,0,2H5Zm9.233-3A.766.766,0,1,0,15,15.233.767.767,0,0,0,14.234,16ZM18,11a1,1,0,1,0,1-1A1,1,0,0,0,18,11ZM13.532,6a.766.766,0,1,0,.767-.767A.767.767,0,0,0,13.532,6ZM6.5,12a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2ZM1,12a1,1,0,0,1,0-2h.5a1,1,0,0,1,0,2Z",
  transform: "translate(-16684 -17404)",
  fill: "inherit"
}))));
export { SvgGatewayIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/GatewayIcon.edabe0cdf4bf07bfe897d4e7e79364db.svg";